<template>
  <div class="header" >
    <div class="section_header" v-bind:class="{white:show1}">
      <div class="logo"></div>
      <div class="navigation">
        <ul class="nav">
            <li @click="totop()"> <router-link  to="/home" >首页</router-link><span class="dot" v-if="$store.state.homeDot"></span></li>
            <li @click="totop()"> <router-link  to="/hard" >硬件产品</router-link><span class="dot" v-if="$store.state.hardDot"></span></li>
            <li @click="totop()"> <router-link  to="/software" >软件服务</router-link><span class="dot" v-if="$store.state.softDot"></span></li>
            <li @click="totop()" class="books">
              <div class="book"><router-link to="">产品手册</router-link><i class="fa fa-caret-down"></i></div>
              <div class="dropdown-menu">
                <div class="dropdown-left">
                  <ul>
                    <li class="dropdown-header">使用者</li>
                    <li><a href="https://www.weimaqi.net/www/2016/product.aspx" target="_blank">产品介绍</a></li>
                    <li><a href="https://www.weimaqi.net/www/2016/tutorial_buycoin.aspx" target="_blank">购币流程</a></li>
                    <li class="divider"></li>
                    <li class="dropdown-header">安装人员</li>
                    <li><a href="https://www.weimaqi.net/www/2016/tutorial_hw_setup_video.aspx" target="_blank">维码器安装视频</a></li>
                    <li><a href="http://q.eqxiu.com/s/OYJFir7B" target="_blank">线上手册</a></li>
                    <li><a href="http://q.eqxiu.com/s/OYJFir7B" target="_blank">手册下载</a></li>
                    <li><a href="https://www.weimaqi.net/www/2016/download/wmq_user_manual.pdf" target="_blank">操作指南下载</a></li>
                    <li class="divider"></li>
                    <li class="dropdown-header">商家/代理</li>
                    <li><a href="https://www.weimaqi.net/www/2016/tutorial_mch_register_video.aspx" target="_blank">自助注册教程</a></li>
                    <li><a href="https://www.weimaqi.net/www/2016/tutorial/mch/alipay_apply/zhifubao.html" target="_blank">支付宝  申请流程</a></li>
                  </ul>
                </div>
                <div class="dropdown-right">
                  <ul>
                    <li class="dropdown-header">收款设置</li>
                    <li><a href="https://weimaqi.oss-cn-shenzhen.aliyuncs.com/%E8%B5%84%E6%96%99/%E5%BE%AE%E4%BF%A1%E5%85%AC%E4%BC%97%E5%8F%B7%E6%94%B6%E6%AC%BE%E7%BB%86%E5%88%99.pdf" target="_blank">微信公众号</a></li>
                    <li><a href="https://www.weimaqi.net/www/2016/tutorial/manual/payment/zishanghu.html" target="_blank">微信子商户</a></li>
                    <li><a href="https://www.weimaqi.net/www/2016/tutorial/manual/payment/zhifubaoshoukuan.html" target="_blank">企业支付宝</a></li>
                    <li><a href="https://weimaqi.oss-cn-shenzhen.aliyuncs.com/%E8%B5%84%E6%96%99/%E6%94%AF%E4%BB%98%E5%AE%9D%E5%BD%93%E9%9D%A2%E4%BB%982021.pdf" target="_blank">支付宝(当面付)</a></li>
                    <li><a href="https://www.yuque.com/docs/share/41819185-84fa-42b3-a878-b901bccf11d2?#" target="_blank">自动提现到银行卡</a></li>
                    <li class="divider"></li>
                    <li class="dropdown-header">微信公众号平台</li>
                    <li><a href="http://kf.qq.com/" target="_blank">公众平台全套流程</a></li>
                    <li><a href="http://kf.qq.com/faq/120911VrYVrA130805byM32u.html" target="_blank">公众号类型</a></li>
                    <li><a href="https://shimo.im/docs/PVAPV2yGMvFmFVql/" target="_blank">吸粉机配置流程</a></li>
                  </ul>
                </div>
              </div>
            </li>
            <li @click="totop()"> <router-link  to="/cooperation" >合作案例</router-link><span class="dot" v-if="$store.state.coopDot"></span></li>
            <li @click="totop()"> <router-link  to="/about" >关于我们</router-link><span class="dot" v-if="$store.state.aboutDot"></span></li>
            <li @click="totop()"><a href="http://en.weimaqi.net/admin/login.aspx">Merchant</a></li>
            <div class="log" @click="toggle()">后台登录</div>
          </ul>
      </div>
    </div>
    <log v-show="$store.state.d2"></log>
  </div>
</template>

<script>
import Log from './login/log'

export default {
  name: 'Navbar',
  components:{Log},
  data() {
    return {
      off:false,
      ok:false,
      closeAgree:false,
      show1:false,
      skrink:false,
      showone:true,
      showtwo:false,
      isActive:false,
      bars: [
        { list: '首页', image: require('../assets/rightline.png'),link:'/home' },
        { list: '硬件产品', image: require('../assets/rightline.png'),link:'/hard' },
        { list: '软件服务', image: require('../assets/rightline.png'),link:'/software' },
        { list: '产品手册', image: require('../assets/rightline.png'),link:''},
        { list: '合作案例', image: require('../assets/rightline.png'),link:'/cooperation' },
        { list: '关于我们', image: require('../assets/rightline.png'),link:'/about' },
      ],
    }
  },
  props:['isFirst'],
  mounted(){
    // window.addEventListener('scroll', this.handleScroll)
  },
  methods:{
    toggle:function(){
      this.$store.state.d2 = !this.$store.state.d2;
      document.documentElement.style.overflow = "hidden";
    },
    totop:function(){
      document.body.scrollTop = 0;        
      document.documentElement.scrollTop = 0
    },
    handleScroll () {
      if (this.$store.state.d4 === '') {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
         if(scrollTop === 0){
          this.show1 = false;
        }else{
          this.show1 = true;
        }
      }
    },
  scale(){
    this.off = !this.off;
  },

    hardPro(){
      this.showone = !this.showone;
      this.showtwo = !this.showtwo;
      this.isActive = !this.isActive;
    }


  },
  // 如果离开该页面需要移除这个监听的事件，不然会报错。
   destroyed () {
   window.removeEventListener('scroll', this.handleScroll)
   },

}
</script>

<style scoped>
.header .nav{
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  transition: all .5s ease;
}
.closes{
  display: none;
}
.header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
}
.section_header{
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;
}
.section_header.white{
  background-color: #fff;
}
/* .section_header.white .nav>li>a,.section_header.white .nav>li>a{
  color: #333;
} */
/* .section_header.white .nav>li.books .book a,
.section_header.white .fa.fa-caret-down{
  color: #333;
}
.section_header.white .nav>li.books:hover .book>a,
.section_header.white .nav>li.books:hover .fa.fa-caret-down{
  color: #016bff;
} */
.section_header.white .logo{
    background: url(../assets/LOGO.png);
    background-size: 100% 100%;
    width: 309px;
    height: 28px;
    margin-left: 50px;
}
/* .section_header.white .nav li.log a{
  color: #fff;
} */
/* .section_header.white .nav>li.log:hover a{
  color: #fff;
} */
/* .section_header.white .nav>li a.router-link-active,
.section_header.white .nav>li:hover a,
.section_header.white .nav>li:hover>a
{
  color: #016bff;
}
.section_header.white .nav li a.router-link-active{
  color: #333;
} */
.section_header .logo{
    background: url(../assets/LOGO.png) no-repeat;
    background-size: 100% 100%;
    width: 309px;
    height: 28px;
    margin-left: 50px;
}
.header .navigation{
  width: 795px;
  height: 100px;
  display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
  position: relative;
  margin-right: 50px;
}
.nav>li:nth-child(1) {
  width: 75px;
}
.nav>li {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    -webkit-box-orient: horizontal; 
    -webkit-box-pack: center;
    -webkit-box-align: center; 
}
.nav>li .dot {
  width: 3px;
  height: 3px;
  background: #016bff;
}
.nav>li .book{
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.nav>li a{
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    font-family: 微软雅黑;
    color: #333;
}

.nav>li a.router-link-active{
  color: #016bff;
}
.nav>li:hover>a{
  color: #016bff;
}

.log{
  color: white;
  font-size: 14px;
  text-align: center;
  width: 110px;
  height: 40px;
  line-height: 40px;
  background: #016bff; 
  font-family: 微软雅黑;
  cursor: pointer;
  margin-left: 10px;
}
/* 产品手册 */
.nav>li.books{
  position: relative;
  top:0px;
  left: 0px;
}
.books .dropdown-menu{
  width: 500px;
  /*height: 500px;*/
  position: absolute;
  top: 100px;
  left: -200px;
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  visibility: hidden;
}
.nav>li.books:hover .dropdown-menu{
  visibility: visible;
  animation: 0.5s div ease-in forwards; 
}
@keyframes div{
0%{height: 10px; }
100%{height: 500px; }
}
.nav>li.books:hover .dropdown-menu li{
  transition-delay: 0.4s;
}
.books .dropdown-menu li{
  width:200px;
  height: 30px;
  line-height: 30px;
}
.books .dropdown-menu .dropdown-header{
  font-size: 14px;
  font-family: 微软雅黑;
  color: #333;
}
.dropdown-menu ul li a{
  width:200px;
  height: 30px;
  color: #68747f;
  font-size: 14px;
  font-family: 微软雅黑;
  display: flex;
}
.dropdown-menu li:hover a{
  color: #016bff;
}
.dropdown-menu li.divider{
  width: 210px;
  height: 1px;
  background: rgba(161, 166, 171, .2);
  margin: 20px 0px;
}
.dropdown-menu .dropdown-left,.dropdown-menu .dropdown-right{
  width: 210px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 44px;
}
.books .dropdown-menu::after{
  content: '';
position: absolute;
  top: -5px;
  left: 230px;
width: 0;
height: 0;
border-left: 10px solid transparent;
border-bottom: 5px solid #fff;
border-right: 10px solid transparent;
}
.fa.fa-caret-down{
  color: #333;
    font-size: 14px;
  margin-left: -12px;
}
.nav>li.books:hover .book>a,.nav>li.books:hover .fa.fa-caret-down{
  color: #016bff;
  cursor: pointer;
}
.nav>li.books .book a{
  color: #333;
}

/* 手机 */
@media screen and (max-width:768px){
  .header{
    display: none;
  }

}

</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue